import { domReady } from '../modules/utils.js';

// Safari fails to autoplay a <video> whose source is chosen via
// <source media="..."> — it never resolves the query in time to satisfy
// the autoplay policy. Instead we render a single <source> and swap its
// src/type in JS based on aspect ratio, which Safari autoplays reliably.
class HeroVideo extends HTMLElement {
  async connectedCallback() {
    await domReady();
    this.video = this.querySelector('video');
    this.source = this.video?.querySelector('source');
    if (!this.video || !this.source) return;

    this.mql = window.matchMedia('(max-aspect-ratio: 1/1)');
    this.#updateSource();
    this.mql.addEventListener('change', this.#updateSource);
  }

  disconnectedCallback() {
    this.mql?.removeEventListener('change', this.#updateSource);
  }

  #updateSource = () => {
    const isPortrait = this.mql.matches;
    // console.log('HeroVideo: isPortrait', isPortrait, 'src', this.source.src);
    const src = isPortrait ? this.dataset.portrait : this.dataset.landscape;
    const type = isPortrait ? this.dataset.portraitType : this.dataset.landscapeType;
    if (!src || this.source.src === src) return;

    this.source.src = src;
    this.source.type = type || '';
    this.video.load();
    this.video.play().catch(() => { });
  };
}

customElements.define('hero-video', HeroVideo);
